const enUSMessages = {
	'page:home:reviewOrder:text': 'Review Order',
	'page:home:viewOpenTab:text': 'View open tab',
	'page:home:tableName:text': 'Table {tableName}',
	'page:home:menuUnavailable:text': "We're sorry, viewing the menu is not available at this time.",
	'page:home:payNow:button': 'Pay Now',
	'page:home:viewCheck:button': 'View Check',
	'page:itemOrder:addItem:button': 'Add Item',
	'page:itemOrder:specialInstructions:label': 'Special Instructions',
	'page:itemOrder:completeRequired:text': 'Please complete required sections to continue.',
	'page:itemOrder:addNote:placeholder': 'Add a note or special request',
	'page:itemOrder:selectRequiredModifiers:text': 'Select required modifiers',
	'page:orderDetails:openTab:heading': 'Open Tab',
	'page:orderDetails:reviewOrder:heading': 'Review Order',
	'page:orderDetails:orderedItemsPreparation:label': 'Ordered items in preparation',
	'page:orderDetails:itemsSelectedPrepared:label': 'Items selected to be prepared',
	'page:orderDetails:remove:button': 'Remove',
	'page:orderDetails:startTab:button': 'Start Tab',
	'page:orderDetails:orderMore:button': 'Order More',
	'page:orderDetails:pay:button': 'Pay',
	'page:orderDetails:placeOrder:button': 'Place Order',
	'page:orderConfirm:tabStarted:heading': 'Your tab has been started!',
	'page:orderConfirm:selectMoreItems:text': 'You have the option to select more items or close out your order.',
	'page:orderConfirm:orderMore:button': 'Order More',
	'page:orderConfirm:pay:button': 'Pay',
	'page:orderConfirm:viewOpenTab:text': 'View open tab',
	'page:orderConfirm:rescanQR:instruction': "To order more and view your tab, you can rescan the table's QR code with this device at any time.",
	'page:customerDetail:didntReceiveCode:text': "Didn't receive code?",
	'page:customerDetail:resend:button': 'Resend',
	'page:customerDetail:name:label': 'Name',
	'page:customerDetail:name:placeholder': 'Name',
	'page:customerDetail:nameQuestion:placeholder': "What's your name?",
	'page:customerDetail:phoneNumber:label': 'Phone number',
	'page:customerDetail:phoneNumber:placeholder': 'Phone number',
	'page:customerDetail:smsCode:label': 'SMS Code',
	'page:customerDetail:smsCode:placeholder': 'Enter 6 digit code',
	'page:customerDetail:deliverOrder:text': 'This helps us deliver your order to you.',
	'page:customerDetail:phoneConfirmation:text': 'We ask for your phone number to help confirm that this order belongs to you.',
	'page:customerDetail:continue:button': 'Continue',
	'page:customerDetail:codeSent:text': 'Code Sent',
	'page:customerDetail:sendConfirmationText:button': 'Send Confirmation Text',
	'page:customerDetail:confirmationCodeSent:text': 'Confirmation code sent to:',
	'page:customerDetail:email:label': 'Email',
	'page:customerDetail:emailQuestion:placeholder': "What's your email?",
	'page:customerDetail:emailExample:placeholder': 'e.g. you@example.com',
	'page:customerDetail:securePayment:text': 'So we can ensure secure payment verification.',
	'page:preAuthDetail:enterDetails:text': 'Please enter the details below',
	'page:preAuthDetail:deliverOrder:text': 'This helps us deliver your order to you.',
	'page:preAuthDetail:table:label': 'Table:',
	'page:preAuthDetail:enterInfo:heading': 'Enter your information',
	'page:preAuthHeader:addCard:heading': 'Add Card',
	'page:preAuthFooter:agreementWithTip:text': "By clicking continue you agree to use this payment method to pay your tab. If you don't pay your tab, it will be paid automatically (including a {tipPercentage}% tip) after 2 hours of inactivity.",
	'page:preAuthFooter:agreementWithoutTip:text': "By clicking continue you agree to use this payment method to pay your tab. If you don't pay your tab, it will be paid automatically after 2 hours of inactivity.",
	'page:selectTicket:headerMessage:text': 'Looks like there are some tickets already open for this table.',
	'page:selectTicket:diningAt:text': 'You are dining at XXXX',
	'page:selectTicket:confirmTicket:button': 'Yes, this is my ticket',
	'page:selectTicket:notMyTicket:button': 'None of these are my ticket',
	'page:selectTicket:contactServer:text': 'Please contact your server to continue',
	'page:selectTicket:total:label': 'Total',
	'page:selectTicket:openTime:label': 'Open Time',
	'page:viewTicket:checkDetails:heading': 'Check Details',
	'page:viewTicket:ticketNumber:label': 'Ticket #:',
	'page:viewTicket:table:label': 'Table:',
	'page:viewTicket:server:label': 'Server:',
	'page:viewTicket:specialRequest:label': 'Special Request:',
	'page:viewTicket:for:label': 'For:',
	'page:viewTicket:subtotal:label': 'Subtotal:',
	'page:viewTicket:discount:label': 'Discount:',
	'page:viewTicket:surcharge:label': 'Surcharge:',
	'page:viewTicket:taxes:label': 'Taxes:',
	'page:viewTicket:taxesIncluded:label': 'Taxes included in prices:',
	'page:viewTicket:tax:label': 'Tax:',
	'page:viewTicket:tip:label': 'Tip:',
	'page:viewTicket:total:label': 'TOTAL:',
	'component:cancelIcon:alt': 'Cancel',
	'component:creditCard:cardholderName:placeholder': 'Name on the card',
	'component:creditCard:cvv2Code:placeholder': '3 digit security code',
	'component:creditCard:postalCode:label': 'Postal Code',
	'component:creditCard:postalCode:placeholder': 'Enter postal code',
	'component:creditCard:postalCode:message': 'Invalid postal code',
	'component:creditCard:streetAddress:placeholder': 'Billing street address',
	'component:creditCard:submitButton:label': 'Continue',
	'component:errorModal:dismiss:button': 'Dismiss',
	'component:footer:balanceDue:label': 'Balance Due:',
	'component:image:warning:alt': 'warning sign',
	'component:image:close:alt': 'close',
	'component:image:back:alt': 'back',
	'component:image:restaurantLogo:alt': 'restaurant name',
	'component:legalConsent:accept:button': 'ACCEPT',
	'component:menuDropdown:confirm:button': 'Confirm',
	'component:legalConsent:header:text': 'Terms and Agreements',
	'component:legalConsent:consentText:text': 'By clicking the Accept button, you agree to the Payment Agreement and Default Tip Policy.',
	'component:specialInstruction:hint:text': 'Dressing on the side? No onions? Let us know here.',
	'component:modifier:required:label': 'Required',
	'component:modifier:optional:label': 'Optional',
	'component:modifier:choose:text': 'Choose {count}',
	'component:modifier:chooseRange:text': 'Choose {min} to {max}',
	'component:modifier:chooseUpTo:text': 'Choose up to {max}',
	'component:modifier:unavailable:text': 'Modifiers are not available',
	'utils:itemOrder:modifierRequired:text': '{name} required.',
	'utils:itemOrder:modifierRequiredExactly:text': '{name} required exactly {count}.',
	'utils:itemOrder:modifierRequiredMinimum:text': '{name} required minimum {count}.',
	'utils:itemOrder:modifierSelectedMoreThan:text': '{name} selected more than {count}.',
	'utils:preAuth:hour:text': '{count} hour',
	'utils:preAuth:hours:text': '{count} hours',
	'utils:preAuth:minute:text': '{count} minute',
	'utils:preAuth:minutes:text': '{count} minutes',
	'utils:preAuth:and:text': ' and ',
	'pages:home:label:validation:phoneNumber:invalid': 'Please provide valid phone number.',
	'pages:home:label:validation:code:invalid': 'Please provide a valid code.',
	'pages:home:label:validation:quantity:invalid': 'Please enter valid quantity.',
	'pages:home:error:invalidGuid:message': 'QR Code is invalid. Please contact a server.',
	'pages:home:error:invalidGuid:title': 'Error',
	'pages:home:error:invalidTicket:message': 'This ticket is closed. Please contact server for more information.',
	'pages:home:error:script:message': 'Something went wrong. Please contact server for more information.',
	'pages:home:error:sessionNotFound:message': 'Sorry, we could not find your session. Please re-identify yourself.',
	'pages:viewTicket:error:partialPayment:message': 'Partial payment was done for this ticket. Contact your server to pay your ticket before leaving.',
	'pages:viewTicket:error:ticketNotFound:message': 'There was a problem initiating payment. Contact your server to pay for ticket before leaving.',
	'pages:orderDetails:error:browserError:message': 'The link is opened in other browser. Please open it again in the same browser you used to place your order.',
	'pages:orderDetails:error:browserError:title': 'Error',
	'pages:orderDetails:error:apiError:404:message': "We couldn't look you up from that link. Please enter name/phone again, and retry.",
	'pages:orderDetails:error:apiError:404:title': 'Retry?',
	'pages:orderDetails:error:apiError:400:message': 'We could not process your request. Please rescan the QR Code and try again.',
	'pages:orderDetails:error:apiError:400:title': 'Error',
	'pages:orderDetails:error:apiError:500:message': 'Contact employee to place your order. There was an error on our side - and we could not submit it for you.',
	'pages:orderDetails:error:apiError:500:title': 'Sorry',
	'pages:orderDetails:error:preAuthApiError:404:message': 'Sorry, we could not find your session. Please re-identify yourself.',
	'pages:orderDetails:error:preAuthApiError:404:title': 'Error',
	'pages:orderDetails:error:preAuthApiError:400:message': 'Sorry, we could not find your session. Please re-identify yourself.',
	'pages:orderDetails:error:preAuthApiError:400:title': 'Error',
	'pages:orderDetails:error:preAuthApiError:500:message': 'Contact employee to place your order. There was an error on our side - and we could not submit it for you.',
	'pages:orderDetails:error:preAuthApiError:500:title': 'Sorry',
	'pages:preAuthDetail:error:authorize:message': 'We could not place an order from this device. Please order directly from a staff member.',
	'pages:preAuthDetail:error:authorize:title': 'Authorized Error',
	'pages:preAuthDetail:error:invalidCard:message': 'Please place order again and re-enter your CC information',
	'pages:preAuthDetail:error:invalidCard:title': 'Invalid Card',
	'pages:preAuthDetail:error:timeout:message': "You're being timed out due to inactivity. Please place your order again.",
	'pages:preAuthDetail:error:timeout:title': '',
	'hooks:usePreAuthScripts:error:recaptchaNotLoaded:message': 'ReCaptcha not loaded',
	'pages:home:error:tableConflict:title': 'Error',
	'pages:home:error:tableConflict:message': 'You already have a tab open at Table {prevTableName}. Please close your current tab before starting a new one.',
	'pages:scanToStart:heading': 'Scan to get started',
	'pages:scanToStart:subTitle': 'Scan the QR code to place an order',
	'pages:scanToStart:footer:text': 'Point your phone\'s camera at the QR code',
	'component:apiErrorModal:retry:button': 'Retry',
	'api:appSessionService:assignTicket:unknownError': 'Something went wrong. Please contact server.',
	'api:appSessionService:assignTicket:userSessionInvalidTicket': 'This check is no longer available.',
	'api:appSessionService:assignTicket:paymentFailed': 'Something went wrong with the payment. Please contact server.',
	'api:appSessionService:assignTicket:validationError': 'Something went wrong. Please contact server.',
	'api:appSessionService:assignTicket:captchaFailed': 'Captcha failed. Please refresh and try again.',
	'api:appSessionService:assignTicket:accessTokenMissing': 'Your session has expired. Please try again later.',
	'api:appSessionService:assignTicket:storeNotFound': 'No store associated with the requested location.',
	'api:appSessionService:assignTicket:userSessionNotFound': 'Your session has timed out or is invalid.',
	'api:appSessionService:assignTicket:ticketNotFound': 'No ticket attached to the session.',
	'api:appSessionService:assignTicket:serviceUnavailable': 'Something went wrong while processing your order. Please contact your server.',
	'api:orderService:placeOrder:userSessionInvalidTicket': 'This check is no longer available.',
	'api:orderService:placeOrder:unknownError': 'Something went wrong. Please contact server.',
	'api:orderService:placeOrder:validationError': 'Something went wrong. Please contact server.',
	'api:orderService:placeOrder:badPayment': 'Your payment could not be processed. Please contact your server.',
	'api:orderService:placeOrder:paymentFailed': 'Something went wrong with the payment. Please contact server.',
	'api:orderService:placeOrder:accessTokenMissing': 'Your session has expired. Please try again later.',
	'api:orderService:placeOrder:captchaFailed': 'Captcha failed. Please refresh and try again.',
	'api:orderService:placeOrder:storeNotFound': 'No store associated with the requested location.',
	'api:orderService:placeOrder:userSessionNotFound': 'Your session has timed out or invalid.',
	'api:orderService:placeOrder:ticketNotCreated': "We couldn't create your check. Please try again or contact your server.",
	'api:orderService:placeOrder:serviceUnavailable': 'Something went wrong while processing your order. Please contact your server.',
	'api:orderService:placeOrder:inputValidationError': 'Input validation error.',
	'api:orderService:placeOrder:transactionFailed': 'Transaction could not be completed. Please try again.',
	'api:orderService:placeOrder:ticketNotFound': 'Ticket not found. Please contact your server.',
} as const;

export default enUSMessages;
